module.exports = __webpack_public_path__ + "media/images/area/area_naganoM400-21df3f3ac47ea5bc3443d571169ced12.jpg";